/* eslint-disable no-restricted-globals */
import api from 'api/index';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const loadData = async ({ setLoading, setTouchFilter, search, setData }) => {
  setLoading(true);
  try {
    const resp = await api({
      method: 'GET',
      url: `/products-partner`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      params: {
        search,
      },
      json: true,
    });

    setLoading(false);
    setData(resp?.data);
    setTouchFilter(false);
  } catch (error) {
    toast.error(error?.response?.data?.error, {
      position: toast.POSITION.TOP_RIGHT,
      theme: 'colored',
    });
  }
};

const handleCreateProductSva = async ({ data, loadData, setLoadingData, setOpenModalAdd, setInputValue, resetValues }) => {
  setLoadingData(true);
  try {
    await api({
      method: 'POST',
      url: `/product-partner`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      data: {
        ...data,
        value: +data.value.replace(/\./g, '').replace(',', '.'),
      },
      json: true,
    });

    toast.success('Produto adicionado com sucesso!', {
      position: toast.POSITION.TOP_RIGHT,
      theme: 'colored',
    });

    resetValues();
    setOpenModalAdd(false);
    setLoadingData(false);
    await loadData();
  } catch (e) {
    setLoadingData(false);
    toast.error(e?.response?.data?.error, {
      position: toast.POSITION.TOP_RIGHT,
      theme: 'colored',
    });
  }
};

const handleRemoveProductSva = async ({ id, loadData, setOpenModalRemove, setLoadingData }) => {
  setLoadingData(true);
  try {
    await api({
      method: 'DELETE',
      url: `/product-partner/${id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      json: true,
    });

    toast.success('Item removido com sucesso!', {
      position: toast.POSITION.TOP_RIGHT,
      theme: 'colored',
    });

    setOpenModalRemove(false);
    await loadData();
  } catch (e) {
    setLoadingData(false);
    toast.error(e?.response?.data?.error, {
      position: toast.POSITION.TOP_RIGHT,
      theme: 'colored',
    });
  } finally {
    setLoadingData(false);
  }
};

const handleUpdateProductSva = async ({ data, setOpenModalEdit, loadData, id, setLoadingData, resetValues }) => {
  try {
    setLoadingData(true);
    await api({
      method: 'PUT',
      url: `/product-partner/${id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      data: {
        ...data,
        value: typeof data.value === 'string' ? +data.value.replace(/\./g, '').replace(',', '.') : data.value,
      },
      json: true,
    });

    toast.success('Produto atualizado!', {
      position: toast.POSITION.TOP_RIGHT,
      theme: 'colored',
    });
    resetValues();
    setOpenModalEdit(false);
    await loadData();
  } catch (e) {
    toast.error('Não foi possível atualizar o item', {
      position: toast.POSITION.TOP_RIGHT,
      theme: 'colored',
    });
  } finally {
    setLoadingData(false);
  }
};

export { loadData, handleCreateProductSva, handleUpdateProductSva, handleRemoveProductSva };
